// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eDe9a","comment":"styles_comment__2sIzQ"};